<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithConfirm()"
        aria-label="Cerrar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'register.success_modal.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-horizontal ion-padding-top">
  <p class="ion-text-wrap">{{ 'register.success_modal.sent' | translate }}</p>
  <p class="ion-text-wrap">{{ 'register.success_modal.review' | translate }}</p>
  <p class="ion-text-wrap">
    {{ 'register.success_modal.email' | translate }} <strong>{{ email }}</strong
    >{{ 'register.success_modal.email_extra' | translate }}
  </p>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            expand="block"
            fill="solid"
            color="primary"
            (click)="closeModalWithConfirm()"
          >
            {{ 'register.success_modal.accept' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
